export default "__VITE_ASSET__BqyqqtBv__"